import { Topbar } from './components/topbar/Topbar'
import { useTopbar } from './logic/useTopbar'
import { useBreakpoint } from '@/ui/utils/useBreakpoint'

export function TopbarContainer() {
  const mediumDisplay = useBreakpoint('md')
  const topbarInfo = useTopbar({
    isMobileDisplay: !mediumDisplay,
  })

  return <Topbar {...topbarInfo} />
}
